// import CryptoJS from "crypto-js";

// const encryptionKey = "16A1CEB9651C300AF5DDE9BBD5F8A04B";
// const ivKey = "000102030405060708090a0b0c0d0e0f";

// // const encryptionKey = "3743EF16DA4378CC938A20FD9FC6CC39";
// // const ivKey = "000102030405060708090a0b0c0d0e0f";


// export function encryptWithAES(plainText) {
//   if (!encryptionKey || !ivKey) {
//     console.error(
//       "Encryption key or IV is missing from environment variables!"
//     );
//     return null;
//   }

//   const key = CryptoJS.MD5(encryptionKey);
//   const iv = CryptoJS.enc.Hex.parse(ivKey);

//   const pad = (data) => {
//     const blockSize = 16;
//     const paddingLength = blockSize - (data.length % blockSize);
//     const paddingChar = String.fromCharCode(paddingLength);
//     return data + paddingChar.repeat(paddingLength);
//   };

//   const paddedText = pad(plainText);
//   const encrypted = CryptoJS.AES.encrypt(
//     CryptoJS.enc.Utf8.parse(paddedText),
//     key,
//     {
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.NoPadding,
//     }
//   );

//   return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
// }

import CryptoJS from 'crypto-js';
import pbkdf2 from 'pbkdf2';

/**
 * Encrypt text using PBKDF2 + AES-CBC
 * @param {string} plainText - Text to encrypt
 * @param {string} workingKey - Secret key
 * @param {string} salt - Salt string (raw string, not base64)
 * @returns {string} Base64-encoded IV + Ciphertext
 */
export function encryptWithAES(plainText, workingKey, salt) {
  if (!workingKey || !salt) {
    console.error("Encryption key or salt is missing!");
    return null;
  }

  // Derive key using PBKDF2 - same as backend
  const key = pbkdf2.pbkdf2Sync(
    workingKey,
    Buffer.from(salt, 'utf-8'), // IMPORTANT: must match `salt.encode()` from Python
    100000,
    32,
    'sha256'
  );

  const aesKey = CryptoJS.enc.Hex.parse(key.toString('hex'));

  // Random 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt using AES-CBC + PKCS7
  const encrypted = CryptoJS.AES.encrypt(plainText, aesKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Concatenate IV + Ciphertext
  const combined = iv.clone().concat(encrypted.ciphertext);

  return CryptoJS.enc.Base64.stringify(combined);
}
